import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Table,
  CardHeader,
  CardFooter,
} from "reactstrap";
import Pagination from "../../../containers/pages/Pagination";
import { Link } from "react-router-dom";
import { Colxx } from "../../../components/common/CustomBootstrap";
import { getAccountsService } from "../../../services/AccountService";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { formattedMobileNumber } from  "../../../utilities/phonenumberutility";
import {
  deleteAccountsService,
  createAccountService,
  updateAccountsService,
  uploadAccountLogo,
  uploadAccountBackGroundImage,
  deleteAccountLogo,
  deleteAccountBackgroundImage,
} from "../../../../src/services/AccountService";
import { toast } from "react-toastify";
import { isNullOrEmpty } from "../../../config/ENV";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";

const Accounts = ({ match, onSearchKey }) => {
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [selectedPageSize, setSelectedPageSize] = useState(2);
  const [modalBasic, setModalBasic] = useState(false);
  const [selectedOrderOption, setSelectedOrderOption] = useState({
    column: "DRAFT",
    label: "DRAFT",
  });
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");

  const [modalDelete, setModalDelete] = useState(false);

  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;
  const [accounts, setAccounts] = useState([]);
  const [modalRight, setModalRight] = useState(false);
  const [size, setSize] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("name");
  const [accountId, setAccountId] = useState("");
  const [accountid, setaccountid] = useState("");
  const [accountname, setaccountname] = useState("");
  const [fileId, setFileId] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountLogo, setSelectedAccontLogo] = useState("");
  const [selectedAccountLogoImage, setSelectedAccontLogoImage] = useState("");
  const [selectedAccountBackGroundImage, setSelectedAccountBackGroundImage] =
    useState("");
  const [selectedAccountBackGround, setSelectedAccountBackGround] =
    useState("");

  const [updateLogoBtnDisabled, setUpdateLogoBtnDisabled] = useState(false);
  const [updateImageBtnDisabled, setUpdateImageBtnDisabled] = useState(false);

  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const [cancelBtnDisabled, setCancelBtnDisabled] = useState(false);
  const [isSortBySelected, setIsSortBySelected] = useState(false);
  const [account, setAccount] = useState({
    name: "",
    email: "",
    // phoneNumber: "",
  });
  const [shortCode, setShortCode] = useState("");

  const inputsHandler = (e) => {
    const { name, value } = e.target;

    if (name === "name" && value !== "") {
      setAccount((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      const code = value.substring(0, 3);
      if (code === "" && name === "shortCode") {
        setShortCode(e.target.value);
      } else {
        setShortCode(code);
      }
    } else {
      setAccount((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const [phoneNumber, setPhoneNumber] = useState("");
  const handlePhoneNumber = (e) => {
    setPhoneNumber(e);
  };
  const handleChangeShortCode = (e) => {
    if (e.target.value.length < 7) {
      setShortCode(e.target.value);
    }
  };

  function handleSearch(e, key) {
    setSearch(e.target.value);
  }

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);

    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }

  const sortByAccounts = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col);
  };
  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }

    getAllAccounts(select, col, currentPage, true);
  };

  useEffect(() => {
    getAllAccounts(sortOrder, sortBy, currentPage, isSortBySelected);
  }, [itemsPerPage, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedPageSize, selectedOrderOption]);

  const getAllAccounts = (sortOrder, sortBy, currentpage, isSortBySelected) => {
    // setCurrentPage(currentpage);

    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (sessionStorage.getItem("accountSortBy") !== null) {
      const sortByValue = sessionStorage.getItem("accountSortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("accountSortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("accountSortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("accountSortBy", sortBy);
    }

    if (sessionStorage.getItem("accountSortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("accountSortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("accountSortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("accountSortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("accountSortOrder", sortOrder);
    }

    setCurrentPage(currentpage);
    getAccountsService(
      search,
      itemsPerPage,
      currentpage,
      sortBy,
      sortOrder
    ).then((response) => {
      let size = response.data.size;
      setSize(size);
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            var accountDetails = response.data.accounts;
            setAccounts(accountDetails);
            const pages = Math.floor(size / itemsPerPage);
            if (Math.round(size % itemsPerPage) > 0) {
              const totalPages = pages + 1;
              setTotalPage(totalPages);
            } else {
              const totalPages = pages;
              setTotalPage(totalPages);
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    });
  };

  const handleaccountdelete = (deleteId, name) => {
    setaccountid(deleteId);
    setaccountname(name);
    setModalDelete(deleteId);
  };
  const removeAccount = (accountId) => {
    deleteAccountsService(accountid).then((response) => {
      try {
        if (response.message != null) {
          //toast.error("Account in use");
          if (response.data.error_message !== "") {
          }
        } else {
          toast.success("Account deleted successfully");
          getAllAccounts(sortOrder, sortBy, currentPage);

          if (response.data != null) {
          }
        }
      } catch (err) {
        console.log("accounts" + JSON.stringify(err.message));
      }
      setModalDelete(false);
    });
  };

  const SubmitAccount = () => {
    if (account.name === "") {
      toast.error("Please enter name");
      return;
    }
    if (shortCode === "") {
      toast.error("Please enter short code");
      return;
    }
    setModalRight(false);
    if (accountId !== "") {
      updateAccount();
    } else {
      createAccount();
    }
  };

  const createAccount = () => {
    const createAccountRequest = {
      name: account.name,
      email: account.email,
      shortCode: shortCode,
      phoneNumber: phoneNumber,
      logo: fileId,
    };
    setSaveBtnDisabled(true);
    setCancelBtnDisabled(true);
    createAccountService(createAccountRequest).then((response) => {
      setSaveBtnDisabled(false);
      setCancelBtnDisabled(false);
      try {
        if (response.data !== null) {
          toast.success("Account created successfully");
          getAllAccounts(sortOrder, sortBy, currentPage);
        }
      } catch (err) {
        console.log("Create account Error" + JSON.stringify(err.message));
      }
    });
  };

  const cancelButton = () => {
    setSaveBtnDisabled(false);
    setCancelBtnDisabled(false);
    setModalRight(false);
  };

  const updateAccount = () => {
    const updateAccountRequest = {
      name: account.name,
      shortCode: shortCode,
      email: account.email,
      // phoneNumber: account.phoneNumber,
      phoneNumber: phoneNumber,
      logo: fileId,
    };
    setSaveBtnDisabled(true);
    setCancelBtnDisabled(true);
    updateAccountsService(updateAccountRequest, accountId).then((response) => {
      setSaveBtnDisabled(false);
      setCancelBtnDisabled(false);
      try {
        if (response.data !== null) {
          toast.success("Account updated successfully");
          getAllAccounts(sortOrder, sortBy, currentPage);
          setAccountId("");
          setAccount((prevState) => ({
            ...prevState,
            name: "",
            email: "",
            // phoneNumber: "",
          }));
        }
      } catch (err) {
        console.log("Update account Error" + JSON.stringify(err.message));
      }
    });
  };

  const updateAccountDetails = (account) => {
    setSelectedAccountBackGround("");
    setSelectedAccontLogoImage("");

    if (document.getElementById("upload-account-bgImage") !== null) {
      document.getElementById("upload-account-bgImage").value = null;
    }

    if (document.getElementById("upload-account-logo") !== null) {
      document.getElementById("upload-account-logo").value = null;
    }

    setUpdateLogoBtnDisabled(false);
    setUpdateImageBtnDisabled(false);

    setSaveBtnDisabled(false);
    setCancelBtnDisabled(false);

    setSelectedAccontLogo("");
    setSelectedAccountBackGroundImage("");

    if (isNullOrEmpty(account.logo)) {
      setSelectedAccontLogoImage("");
    } else {
      setSelectedAccontLogoImage(account.logo);
    }

    if (isNullOrEmpty(account.bgImage)) {
      setSelectedAccountBackGround("");
    } else {
      setSelectedAccountBackGround(account.bgImage);
    }

    setModalRight(true);
    setAccount((prevState) => ({
      ...prevState,
      name: account.name,
      email: account.email,
      // phoneNumber: account.phoneNumber,
    }));
    setSelectedAccount(account);
    setAccountId(account.id);
    setShortCode(account.shortCode);
    setPhoneNumber(account.phoneNumber);
  };

  const openModel = () => {
    setShortCode("");
    setModalRight(true);
    setAccountId("");
    setAccount((prevState) => ({
      ...prevState,
      name: "",
      email: "",
      // phoneNumber: "",
    }));
    setPhoneNumber("");
  };

  const onFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedAccontLogo(URL.createObjectURL(event.target.files[0]));
    }
    let file = document.getElementById("upload-account-logo").files[0];
    let fd = new FormData();
    fd.append("file", file);
    setUpdateLogoBtnDisabled(true);
    uploadAccountLogo(selectedAccount.id, fd).then((response) => {
      setUpdateLogoBtnDisabled(false);
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            toast.success("Logo upload successfully");
            document.getElementById("upload-account-logo").value = null;
            getAllAccounts(sortOrder, sortBy, currentPage);
          }
        }
      } catch (err) {
        console.log("err " + JSON.stringify(err));
      }
    });
  };

  const onBackGroundImageFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedAccountBackGroundImage(
        URL.createObjectURL(event.target.files[0])
      );
    }
    let file = document.getElementById("upload-account-bgImage").files[0];
    let fd = new FormData();
    fd.append("file", file);
    setUpdateImageBtnDisabled(true);
    uploadAccountBackGroundImage(selectedAccount.id, fd).then((response) => {
      setUpdateImageBtnDisabled(false);
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            document.getElementById("upload-account-bgImage").value = null;
            toast.success("Background upload successfully");

            getAllAccounts(sortOrder, sortBy, currentPage);
          }
        }
      } catch (err) {
        console.log("err " + JSON.stringify(err));
      }
    });
  };

  const deleteLogo = (accountId) => {
    deleteAccountLogo(accountId).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            toast.success("Account logo deleted successfully");
            if (document.getElementById("upload-account-logo").value !== null) {
              document.getElementById("upload-account-logo").value = null;
            }
            setSelectedAccontLogo("");
            setSelectedAccontLogoImage("");
            getAllAccounts(sortOrder, sortBy, currentPage);
          }
        }
      } catch (err) {
        console.log("err " + JSON.stringify(err));
      }
    });
  };

  const deleteBackgroundImage = (accountId) => {
    deleteAccountBackgroundImage(accountId).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            toast.success("Background image deleted successfully");
            document.getElementById("upload-account-bgImage").value = null;
            setSelectedAccountBackGroundImage("");
            setSelectedAccountBackGround("");
            getAllAccounts(sortOrder, sortBy, currentPage);
          }
        }
      } catch (err) {
        console.log("err " + JSON.stringify(err));
      }
    });
  };

  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  const displayTableHeaders = () => {
    return (
      <>
        <th className="w-5">S. No</th>
        <th className="w-10">Logo</th>

        <th onClick={() => sortByAccounts("name")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Name </div>
            <div className="col">
              {sortBy == "name" ? (
                <>
                  {sortBy === "name" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-10 ">Contact Name</th>
        <th onClick={() => sortByAccounts("shortCode")} className="w-5">
          <Row className="w-[150]">
            <div className="col-7 pr-1 t-cursor-pointer"> Short Code </div>
            <div className="col-1">
              {sortBy == "shortCode" ? (
                <>
                  {" "}
                  {sortBy === "shortCode" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                       <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>

        <th className="w-10">Email</th>
        <th className="w-10">Mobile Number</th>
        <th onClick={() => sortByAccounts("createdOn")} className="w-10">
          <Row className="w-[150]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Creation Date </div>
            <div className="col-1">
              {sortBy === "createdOn" ? (
                <>
                  {sortBy === "createdOn" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                       <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-10">Actions</th>
      </>
    );
  };

  const accountLogoAndBackgroundImageUI = () => {
    return (
      <>
        {accountId !== "" ? (
          <>
            <Colxx sm={12}>
              <hr />
            </Colxx>
            <Colxx sm={12}>
              <div className="skill-header">
                <Label>
                  <b>Account Logo</b>
                </Label>
                <>
                  <label
                    htmlFor="upload-account-logo"
                    className="btn btn-outline-primary fileinput-button btn-sm"
                  >
                    Upload
                  </label>
                  <input
                    type="file"
                    id="upload-account-logo"
                    accept="image/png,image/jpeg"
                    style={{ display: "none" }}
                    disabled={updateLogoBtnDisabled}
                    onChange={(e) => {
                      onFileChange(e, account);
                    }}
                  />
                </>
              </div>
            </Colxx>
            <Colxx sm={12}>
              <FormGroup>
                <div className="skill-header">
                  {selectedAccountLogo !== "" ? (
                    <>
                      <img
                        src={selectedAccountLogo}
                        alt="logo"
                        className="account-logo"
                      />
                      <i
                        title="Delete Logo"
                        className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-3"
                        onClick={() => deleteLogo(selectedAccount.id)}
                      />
                    </>
                  ) : (
                    !isNullOrEmpty(selectedAccountLogoImage) && (
                      <>
                        <img
                          src={selectedAccountLogoImage}
                          alt="logo"
                          className="account-logo-bg"
                        />
                        <i
                          title="Delete Logo"
                          className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-3"
                          onClick={() => deleteLogo(selectedAccount.id)}
                        />
                      </>
                    )
                  )}
                </div>
              </FormGroup>
            </Colxx>
            <Colxx sm={12}>
              <hr />
            </Colxx>
            <Colxx sm={12}>
              <div className="skill-header">
                <Label>
                  <b>Background Image</b>
                </Label>
                <>
                  <label
                    htmlFor="upload-account-bgImage"
                    className="btn btn-outline-primary fileinput-button btn-sm"
                  >
                    Upload
                  </label>
                  <input
                    type="file"
                    id="upload-account-bgImage"
                    accept="image/png,image/jpeg"
                    disabled={updateImageBtnDisabled}
                    style={{ display: "none" }}
                    onChange={(e) => {
                      onBackGroundImageFileChange(e, account);
                    }}
                  />
                </>
              </div>
            </Colxx>
            <Colxx sm={12}>
              <FormGroup>
                <div className="skill-header">
                  {selectedAccountBackGroundImage !== "" ? (
                    <>
                      <img
                        src={selectedAccountBackGroundImage}
                        alt="background image"
                        className="account-logo"
                      />
                      <i
                        type="button"
                        title="Delete background image"
                        className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1"
                        onClick={() =>
                          deleteBackgroundImage(selectedAccount.id)
                        }
                      />
                    </>
                  ) : (
                    !isNullOrEmpty(selectedAccountBackGround) && (
                      <>
                        <img
                          src={selectedAccountBackGround}
                          alt="background image"
                          className="account-logo-bg"
                        />
                        <i
                          className="simple-icon-trash ic-profile  text-dark delete-icon ml-2 emp_icon"
                          title="Delete background image"
                          onClick={() =>
                            deleteBackgroundImage(selectedAccount.id)
                          }
                        />
                      </>
                    )
                  )}
                </div>
              </FormGroup>
            </Colxx>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      <div>
        <div>
          <Card className="mt-2">
            <CardHeader>
              <div>
                <Row>
                  <Colxx xxs="12">
                    <div className="skill-header">
                      <strong>Accounts</strong>
                      <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={openModel}
                      >
                        Add
                      </Button>

                      <Modal
                        scrollable={true}
                        isOpen={Boolean(modalRight)}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <ModalHeader className="Modal-header-account">
                          {accountId === "" ? (
                            <strong>Create Account</strong>
                          ) : (
                            <strong>Update Account</strong>
                          )}
                        </ModalHeader>
                        <ModalBody>
                          <Form>
                            <FormGroup row>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    Account Name*
                                    {/* <span className="required-star"></span> */}
                                  </Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="name"
                                    name="name"
                                    data-testid="account-name"
                                    onChange={inputsHandler}
                                    value={account.name}
                                    // placeholder={"Name"}
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>
                                    Account Code*
                                    {/* <span className="required-star"></span> */}
                                  </Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="name"
                                    name="name"
                                    data-testid="account-shortcode"
                                    onChange={handleChangeShortCode}
                                    value={shortCode}
                                  />
                                </FormGroup>
                              </Colxx>
                              {accountLogoAndBackgroundImageUI()}
                            </FormGroup>
                          </Form>
                        </ModalBody>

                        <ModalFooter className="model-button modal-bottom-account">
                          <Button
                            color="primary"
                            size="sm"
                            outline
                            onClick={SubmitAccount}
                            disabled={saveBtnDisabled}
                          >
                            Save
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className=" ml-1"
                            onClick={cancelButton}
                            disabled={cancelBtnDisabled}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </div>
                  </Colxx>
                </Row>
              </div>
            </CardHeader>
            <CardBody>
              <div className="mb-3">
                <Row>
                  <Colxx xs={12}>
                    <Row>
                      <Colxx md={4}>
                        {/* <Label className="account_label">Search</Label> */}
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control t-input-group-left-radius "
                            name=""
                            placeholder="Search"
                            onChange={handleSearch}
                            value={search}
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-primary btn-sm t-input-group-right-radius"
                              onClick={(e) =>
                                getAllAccounts(sortOrder, sortBy, 1)
                              }
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </Colxx>
                      <Colxx md={4}></Colxx>
                      <Colxx md={4}>
                        <Input
                          className="t-rounded-lg"
                          type="select"
                          value={itemsPerPage}
                          onChange={handleItemsPerChange}
                        >
                          <option value={""}>Items Per Page</option>
                          <option value={"10"}>10</option>
                          <option value={"25"}>25</option>
                          <option value={"50"}>50</option>
                          <option value={"100"}>100</option>
                        </Input>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </div>
              <div className="tableContainer">
                <div className="tablewrapper">
                  <Table className="hms_table  jobRequisition_table  table-responsive">
                    <thead>
                      <tr>{displayTableHeaders()}</tr>
                    </thead>
                    {accounts.length > 0 ? (
                      accounts.map((account, index) => {
                       
                        const startDate = new Date(
                          account.createdOn
                        ).toDateString();
                        return (
                          <tbody key={index}>
                            <tr>
                              <td className="w-[60]">
                                {getSerialNumber(index)}
                              </td>
                              <td className="w-[120]">
                                {!isNullOrEmpty(account.logo) ? (
                                  <img
                                    src={account.logo}
                                    className="account-logo"
                                  ></img>
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td className="w-[120]">
                                <u>
                                  <span
                                    className="text-dark t-cursor-pointer"
                                    onClick={(e) => {
                                      updateAccountDetails(account);
                                    }}
                                  >
                                    {account.name}
                                  </span>
                                </u>
                              </td>
                              <td className="w-[120]">
                                {!isNullOrEmpty(account.primaryContact) ? (
                                  <>
                                    {account.primaryContact.firstName}{" "}
                                    {account.primaryContact.lastName}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td className="w-[60]">{account.shortCode}</td>
                              <td className="w-[120]">
                                {!isNullOrEmpty(account.primaryContact) &&
                                  account.primaryContact.email}
                              </td>
                              <td className="w-[120]">
                                {!isNullOrEmpty(account.primaryContact) &&
                                  formattedMobileNumber(
                                    account.primaryContact.mobileNumber
                                  )}
                              </td>
                              <td className="w-[120]">{startDate}</td>
                              <td className="w-[60]">
                                <div className="actionbutton">
                                  <Link
                                    className="benifit-symbol-color"
                                    to={{pathname:`/contact/${account.id}/${account.name}`}}
                                    title="Account Contacts"
                                   
                                  >
                                    <i
                                      className=" w-5 simple-icon-user-follow mr-1 arrow-icon-color"
                                      color="red"
                                    />
                                  </Link>
                                  <Link
                                    className="benifit-symbol-color"
                                    to={{pathname : `/address/${account.id}/${account.name}`}}
                                    title="Account Locations"
                                    
                                  >
                                    <i className="iconsminds-location-2" />
                                  </Link>{" "}
                                  <Link
                                    className="benifit-symbol-color mr-1"
                                    to={{pathname : `/accountbenefits/${account.id}`}}
                                    title="Account Benefits"
                                    
                                  >
                                    <i className="iconsminds-financial" />
                                  </Link>
                                  <i
                                    title="Delete Account"
                                    className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 t-cursor-pointer"
                                    onClick={() =>
                                      handleaccountdelete(
                                        account.id,
                                        account.name
                                      )
                                    }
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Table>
                </div>
              </div>

              {accounts.length > 0 ? (
                <></>
              ) : (
                <p className="nodata-text">No accounts available</p>
              )}
            </CardBody>

            <CardFooter>
              <Row className="wrapper">
                <h3 className="ml-3 matrecords">
                  {" "}
                  Total matching records : {size}
                </h3>
                <Pagination
                  currentPage={currentPage}
                  totalPage={totalPage}
                  numberLimit={itemsPerPage}
                  firstIsActive={true}
                  onChangePage={(e) => onChangePage(e)}
                />
              </Row>
            </CardFooter>
          </Card>
        </div>
      </div>

      <Modal isOpen={Boolean(modalBasic)} toggle={() => setModalBasic(!modalBasic)}>
        <ModalHeader></ModalHeader>
        <ModalBody>
          <input
            id="imageFile"
            type="file"
            onChange={(e) => {
              onFileChange(e, account);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            outline
            color="primary"
            size="sm"
            onClick={() => setModalBasic(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            outline
            color="primary"
            size="sm"
            onClick={() => setModalBasic(false)}
          >
            Save
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal  isOpen={Boolean(modalDelete)} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody>
          Do you want to delete account <strong> {"  " + accountname}</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              removeAccount();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Accounts;
